import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./../../../assets/css/mentor/MentorApplicationForm/MentorApplicationForm.css";
import { useContext } from "react";
import AppContext from "../../../context/Appcontext";

const MentorApplicationForm = () => {
  const { regExpChecker } = useContext(AppContext);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    primarySkill: "",
    yearsOfExperience: "",
    profileUrl: "",
    motivation: "",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const primarySkillOptions = [
    "Frontend Development",
    "Backend Development",
    "Full Stack Development",
    "UI/UX Design",
    "AI / Machine Learning",
    "Data Science",
    "Cyber Security",
  ];

  const experienceOptions = [
    "Less than 1 year",
    "1–2 years",
    "3–5 years",
    "5+ years",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const isFormValid = () => {
    return (
      formData.firstName.trim() !== "" &&
      formData.lastName.trim() !== "" &&
      formData.email.trim() !== "" &&
      formData.primarySkill !== "" &&
      formData.yearsOfExperience !== "" &&
      formData.motivation.trim() !== "" &&
      !errors.firstName &&
      !errors.lastName &&
      !errors.email &&
      !errors.profileUrl
    );
  };

  const handleSubmit = () => {
    if (isFormValid()) {
      setIsSubmitted(true);
      console.log("Form submitted:", formData);
    }
  };

  const handleNewApplication = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      primarySkill: "",
      yearsOfExperience: "",
      profileUrl: "",
      motivation: "",
    });
    setIsSubmitted(false);
  };

  return (
    <div className="mentor-application-container">
      {!isSubmitted ? (
        <>
          {/* Header */}
          <div className="form-header">
            <p className="form-subtitle">
              Apply to become a verified mentor on Tech Mentor Hub
            </p>
          </div>

          {/* Form */}
          <div className="application-form">
            {/* Row 1: First Name + Last Name */}
            <div className="form-row two-col">
              <div className="form-group">
                <label htmlFor="firstName" className="form-label">
                  First Name <span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={(e) => {
                    handleChange(e);
                    setErrors((prev) => ({
                      ...prev,
                      firstName: regExpChecker("firstName", e.target.value),
                    }));
                  }}
                  placeholder="Enter your first name"
                  className="form-input"
                />
                {errors.firstName && (
                  <span className="field-error">{errors.firstName}</span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="lastName" className="form-label">
                  Last Name <span className="required-asterisk">*</span>
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={(e) => {
                    handleChange(e);
                    setErrors((prev) => ({
                      ...prev,
                      lastName: regExpChecker("lastName", e.target.value),
                    }));
                  }}
                  placeholder="Enter your last name"
                  className="form-input"
                />
                {errors.lastName && (
                  <span className="field-error">{errors.lastName}</span>
                )}
              </div>
            </div>

            {/* Row 2: Email + LinkedIn */}
            <div className="form-row two-col">
              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email Address <span className="required-asterisk">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => {
                    handleChange(e);
                    setErrors((prev) => ({
                      ...prev,
                      email: regExpChecker("email", e.target.value),
                    }));
                  }}
                  placeholder="your.email@example.com"
                  className="form-input"
                />
                {errors.email && (
                  <span className="field-error">{errors.email}</span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="profileUrl" className="form-label">
                  LinkedIn or GitHub Profile
                </label>
                <input
                  type="url"
                  id="profileUrl"
                  name="profileUrl"
                  value={formData.profileUrl}
                  onChange={(e) => {
                    handleChange(e);
                    setErrors((prev) => ({
                      ...prev,
                      profileUrl: regExpChecker("profileUrl", e.target.value),
                    }));
                  }}
                  placeholder="https://linkedin.com/in/yourprofile"
                  className="form-input"
                />
                {errors.profileUrl && (
                  <span className="field-error">{errors.profileUrl}</span>
                )}
              </div>
            </div>

            {/* Row 3: Primary Skill + Experience */}
            <div className="form-row two-col">
              <div className="form-group">
                <label htmlFor="primarySkill" className="form-label">
                  Primary Skill <span className="required-asterisk">*</span>
                </label>
                <select
                  id="primarySkill"
                  name="primarySkill"
                  value={formData.primarySkill}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">Select your primary skill</option>
                  {primarySkillOptions.map((skill, index) => (
                    <option key={index} value={skill}>
                      {skill}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="yearsOfExperience" className="form-label">
                  Years of Experience{" "}
                  <span className="required-asterisk">*</span>
                </label>
                <select
                  id="yearsOfExperience"
                  name="yearsOfExperience"
                  value={formData.yearsOfExperience}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="">Select experience level</option>
                  {experienceOptions.map((exp, index) => (
                    <option key={index} value={exp}>
                      {exp}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 4: Motivation  */}
            <div className="form-row one-col">
              <div className="form-group">
                <label htmlFor="motivation" className="form-label">
                  Motivation <span className="required-asterisk">*</span>
                </label>
                <textarea
                  id="motivation"
                  name="motivation"
                  value={formData.motivation}
                  onChange={handleChange}
                  placeholder="Tell us why you want to become a mentor on Tech Mentor Hub..."
                  className="form-textarea"
                  rows="3"
                />
              </div>
            </div>

            {/* Submit Button */}
            <div className="form-row one-col">
              <button
                onClick={handleSubmit}
                className="submit-button"
                disabled={!isFormValid()}
              >
                Submit Application
              </button>
            </div>
          </div>
        </>
      ) : (
       
        <div className="success-container">
          <div className="success-message">
            {/* Check icon */}
            <div className="success-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>

            <h2 className="success-title">Application Submitted</h2>
            <p className="success-text">
              Your application has been submitted for review. You will be
              notified once you're eligible for the mentor assessment.
            </p>

            <button
              onClick={handleNewApplication}
              className="new-application-button"
            >
              Submit Another Application
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MentorApplicationForm;
